Bingo.FileUpload = {};

Bingo.FileUpload.init = function () {
    $('.custom-file-input').on('change', function () {
        const self = $(this);
        const fileName = self.val().split('\\').pop();
        self.parent().addClass('selected');
        self.parent().find('.custom-file-label').html(fileName);
    });
};
